import { QueueRule } from '@rossum/api-client/schemas';
import { emailActionPayloadSchema } from '../actions/EmailAction';

export const getReferencedEmailTemplateUrls = (rule: QueueRule): string[] => {
  return rule.actions.flatMap(action => {
    if (action.type !== 'send_email') return [];
    const parsed = emailActionPayloadSchema().safeParse(action.payload);
    return parsed.success && parsed.data.email_template
      ? [parsed.data.email_template]
      : [];
  });
};
